// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"20":"0679a495","408":"e457d986","435":"27181dd1","445":"4c767840","858":"92b72549","908":"3011a4d3"}[chunkId] + ".chunk.js";
};